<div class="gate-info-small">
  <div class="gate-info-small__header">
    <div class="gate-info-small__activations">
      @if (noActivationLabel(); as label) {
        <span class="gate-info-small__no-activation" [title]="label" aria-hidden="false" [attr.aria-label]="label">
          <i eIcon icon="circle-minus"></i>
        </span>
      } @else {
        @for (glyph of planetGlyphs(); track glyph.key) {
          <span
            class="gate-info-small__glyph"
            [class.gate-info-small__glyph--design]="glyph.isDesign"
            [title]="glyph.name"
            [attr.aria-label]="glyph.name"
          >{{ glyph.char }}</span>
        }
      }
    </div>
  </div>

  <hd-gate-info-cheat-sheet
    [context]="cheatSheetContext()"
    [visualState]="cheatSheetVisualState()"
  />
</div>
